export default "__VITE_ASSET__e5HgYRzN__"